// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__cE-oz","name":"Header_name__3AQMq","birthday":"Header_birthday__2tFjm","skeleton":"Header_skeleton__1j2IY"};